export default "__VITE_ASSET__B_N9FbER__"